import script from "./CoWorkersView.vue?vue&type=script&setup=true&lang=js"
export * from "./CoWorkersView.vue?vue&type=script&setup=true&lang=js"

import "./CoWorkersView.vue?vue&type=style&index=0&id=ed755496&lang=scss"

const __exports__ = script;

export default __exports__